import { useEffect, Component, ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useScrollToAnchor } from "@/hooks/useScrollToAnchor";
import Header from "@/components/landing-v2/Header";
import HeroSection from "@/components/landing-v2/HeroSection";
import BelowFoldSections from "@/components/landing-v2/BelowFoldSections";
import BottomSections from "@/components/landing-v2/BottomSections";
import MobileConsultationBar from "@/components/landing-v2/MobileConsultationBar";
// MAIN LANDING PAGE - iOS Safari Optimized

// Error Boundary Component
interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class LandingErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-[#F9B896] to-[#FCCAB0]">
          <div className="text-center p-8">
            <h1 className="text-2xl font-bold text-gray-900 mb-4">Coś poszło nie tak</h1>
            <p className="text-gray-600 mb-6">Przepraszamy za niedogodności. Spróbuj odświeżyć stronę.</p>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-3 bg-orange-500 text-white rounded-full font-medium hover:bg-orange-600 transition-colors"
            >
              Odśwież stronę
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

const NewLanding = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  useScrollToAnchor();

  useEffect(() => {
    if (user) {
      navigate("/panel", { replace: true });
    }
  }, [user, navigate]);

  return (
    <LandingErrorBoundary>
      <div
        className="relative min-h-screen pb-28 md:pb-0"
        style={{ background: '#fff' }}
      >
        {/* Depth vignette — darkens edges, brightens center for concave illusion */}
        <div
          className="pointer-events-none fixed inset-0 z-40"
          style={{
            background: "radial-gradient(ellipse 70% 60% at 50% 50%, transparent 0%, rgba(0,0,0,0.06) 100%)",
          }}
          aria-hidden="true"
        />
        <Header />
        <HeroSection />
        <BelowFoldSections />
        <BottomSections />
        <MobileConsultationBar />
      </div>
    </LandingErrorBoundary>
  );
};

export default NewLanding;
